<template>
  <div class="single-effect-editor">
    <LabelOption
      :label="label"
      :optionList="effectList"
      v-model="effectType"
      :disabled="disabled"
      @change="handleChange"
    >
      <el-tooltip content="删除特效" placement="top-end">
        <a-button
          v-if="deletable"
          class="single-effect-delete ant-btn-icon-only iconfont"
          size="small"
          @click="handleDelete"
          :disabled="disabled"
          type="link"
          >&#xe6b4;</a-button
        >
      </el-tooltip>
    </LabelOption>
    <div v-show="tipShow" class="tips">
      该特效由逐个字符运算生成，您的文案比较长，将会导致视频生成速度变慢
    </div>
    <LabelInput
      label="特效开始（秒）"
      :time="true"
      v-model="track.start"
      :disabled="disabled"
    />
    <LabelInput
      label="持续时长（秒）"
      :time="true"
      v-model="displayDuration"
      :disabled="disabled"
    />
    <effect-param-editor
      v-for="desc in effectDescs"
      :disabled="disabled"
      :tag="desc.tag"
      :attrs="desc.attrs"
      v-model="track.params[desc.prop]"
      :key="desc.prop"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import LabelInput from "./LabelInput";
import LabelOption from "./LabelOption";
import EffectParamEditor from './EffectParamEditor';
import { effectParamDescs, effectParams } from '../../utils/textEffectMap';

export default {
  props: ['label', 'track', 'disabled', 'effectList', 'deletable'],
  components: { LabelInput, LabelOption, EffectParamEditor },
  computed: {
    ...mapGetters(['selectedEffect']),
    effectType: {
      get() {
        return this.track.effectType;
      },
      set(value) {
        this.$set(this.track, 'effectType', value);
        this.$set(this.track, 'params', effectParams[value] ? { ...effectParams[value] } : null);
        this.isShowTip()
      }
    },
    effectDescs() {
      return this.track && effectParamDescs[this.track.effectType] || [];
    },
    displayDuration: {
      get() {
        if (this.track) {
          return this.track.duration;
        }
        return 0;
      },
      set(value) {
        if (this.track) {
          this.track.duration = Math.max(value, 400);
        }
      }
    }
  },
  data() {
    return {
      tipShow: false
    }
  },
  methods: {
    isShowTip() {
      let effectType = this.effectType
      // 开启特效：逐行滑动/逐行多次滑动/逐字符滑动/波浪 && 文案大于等于20 时显示提示
      if ((effectType == 'ceilWaveLine' || effectType == 'flutter' || effectType == 'rowFlutter' || effectType == 'slideDrictionShow') && this.selectedEffect.content.text.length >= 20 && !this.disabled) {
        this.tipShow = true
      } else {
        this.tipShow = false
      }
    },
    handleDelete() {
      this.$emit('delete');
    }
  },
  watch: {
    'disabled': {
      handler(val) {
        this.isShowTip()
      },
      immediate: true
    },
    'selectedEffect.content.text': {
      handler(val) {
        this.isShowTip()
      },
      immediate: true
    }
  }
}
</script>
<style scoped>
.single-effect-editor + .single-effect-editor {
  margin-top: 12px;
  border-top: 1px solid #dcdcdc;
  padding-top: 2px;
}

.single-effect-delete {
  color: rgba(0, 0, 0, 0.75);
  margin-left: 3px;
  font-size: 15px;
  line-height: 1;
}

.single-effect-delete:hover,
.single-effect-delete:focus {
  color: #007eff;
}

.single-effect-delete:disabled {
  color: rgba(0, 0, 0, 0.2);
}
.tips {
  font-size: 12px;
  color: #e95c24;
  margin-top: 10px;
}
</style>